import Layout from '@/layout/default' 

const downloadRouter = {
  path: '/download',
  name: 'download',
  component: Layout,
  children: [
      {
            path: '', // 下载页面
            name: 'download',
            meta: {
                isShowHeader: true,
                isShowNav: true
            },
          component: () => import('@/views/download/index.vue')
      }
  ]
}

export default downloadRouter
